var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canRender)?_c('div',{ref:"leafletContainer",staticClass:"vc-leaflet-control-minimap",style:(_vm.ovStyle),attrs:{"id":"vc-overview-map"}}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }